(function () {
  function init(bar) {
    if (bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    var existing = document.body.querySelector(':scope > #' + bar.id);
    if (existing && existing !== bar) existing.remove();
    if (bar.parentElement !== document.body) document.body.appendChild(bar);
    var sectionId = bar.dataset.sectionId;
    var mainButton = document.getElementById('ProductSubmitButton-' + sectionId);
    var priceWrap = document.getElementById('price-' + sectionId);
    var barPrice = bar.querySelector('[data-mobile-buy-price]');
    var barButton = bar.querySelector('[data-mobile-buy-button]');

    function syncPrice() {
      if (!priceWrap || !barPrice) return;
      var item = priceWrap.querySelector('.price--on-sale .price-item--sale') ||
        priceWrap.querySelector('.price__regular .price-item--regular') ||
        priceWrap.querySelector('.price-item');
      if (item) barPrice.textContent = item.textContent.trim();
    }

    function syncButton() {
      if (!mainButton || !barButton) return;
      var unavailable = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      barButton.disabled = mainButton.disabled;
      barButton.classList.toggle('loading', mainButton.classList.contains('loading'));
      if (!unavailable) barButton.removeAttribute('aria-disabled');
    }

    if (priceWrap) new MutationObserver(syncPrice).observe(priceWrap, { childList: true, subtree: true, characterData: true });
    if (mainButton) {
      new MutationObserver(syncButton).observe(mainButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          bar.hidden = entries[0].isIntersecting;
        }).observe(mainButton);
      }
    }
    syncPrice();
    syncButton();
  }

  function initAll() {
    document.querySelectorAll('.divergent-mobile-buy').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
